var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashcards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 175C58.5774 175 25 141.423 25 100C25 58.5774 58.5774 25 100 25C141.423 25 175 58.5774 175 100C175 141.423 141.423 175 100 175Z",
    fill: "url(#paint0_linear_26801_3621)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62C15 55.3726 20.3726 50 27 50H133C139.627 50 145 55.3726 145 62V138C145 144.627 139.627 150 133 150H27C20.3726 150 15 144.627 15 138V62Z",
    fill: "url(#paint1_linear_26801_3621)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186 74C186 67.3726 180.627 62 174 62H112C105.373 62 100 67.3726 100 74V115.065C100 121.693 105.373 127.065 112 127.065H134.889C135.994 127.065 136.889 127.961 136.889 129.065V139L148.528 127.634C148.901 127.269 149.403 127.065 149.925 127.065H174C180.627 127.065 186 121.693 186 115.065V74Z",
    fill: "url(#paint2_linear_26801_3621)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.912 113.296L145.895 113.299L145.787 113.353L145.757 113.359L145.735 113.353L145.627 113.299C145.611 113.294 145.599 113.297 145.591 113.307L145.585 113.322L145.559 113.974L145.566 114.004L145.581 114.024L145.74 114.137L145.763 114.143L145.781 114.137L145.939 114.024L145.958 114L145.964 113.974L145.938 113.324C145.934 113.307 145.925 113.298 145.912 113.296ZM146.315 113.124L146.295 113.127L146.014 113.269L145.999 113.284L145.994 113.301L146.021 113.955L146.029 113.974L146.041 113.984L146.347 114.126C146.367 114.131 146.381 114.127 146.391 114.114L146.397 114.092L146.346 113.158C146.341 113.139 146.33 113.128 146.315 113.124ZM145.227 113.127C145.22 113.123 145.212 113.122 145.204 113.124C145.197 113.125 145.19 113.13 145.186 113.136L145.177 113.158L145.125 114.092C145.126 114.111 145.134 114.123 145.151 114.129L145.173 114.126L145.479 113.984L145.495 113.972L145.501 113.955L145.527 113.301L145.522 113.282L145.507 113.267L145.227 113.127Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.541 85.6694C159.97 86.0976 160.21 86.6783 160.21 87.2839C160.21 87.8894 159.97 88.4701 159.541 88.8984L142.425 106.015C142.199 106.241 141.93 106.42 141.635 106.543C141.339 106.665 141.023 106.728 140.703 106.728C140.383 106.728 140.066 106.665 139.77 106.543C139.475 106.42 139.206 106.241 138.98 106.015L130.476 97.5121C130.258 97.3014 130.084 97.0494 129.964 96.7708C129.845 96.4922 129.782 96.1926 129.779 95.8893C129.776 95.5861 129.834 95.2854 129.949 95.0048C130.064 94.7241 130.233 94.4692 130.448 94.2548C130.662 94.0403 130.917 93.8708 131.198 93.756C131.478 93.6411 131.779 93.5834 132.082 93.586C132.385 93.5886 132.685 93.6516 132.964 93.7713C133.242 93.891 133.494 94.065 133.705 94.2831L140.702 101.28L156.311 85.6694C156.523 85.4572 156.775 85.2888 157.052 85.174C157.329 85.0591 157.626 85 157.926 85C158.226 85 158.523 85.0591 158.8 85.174C159.078 85.2888 159.329 85.4572 159.541 85.6694Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5 69.9C49.8844 69.9 42.9 76.8844 42.9 85.5C42.9 94.1157 49.8844 101.1 58.5 101.1C67.1157 101.1 74.1 94.1157 74.1 85.5C74.1 76.8844 67.1157 69.9 58.5 69.9ZM39 85.5C39 74.7304 47.7304 66 58.5 66C69.2695 66 78 74.7304 78 85.5C78 96.2695 69.2695 105 58.5 105C47.7304 105 39 96.2695 39 85.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0369 80.3107C57.3971 79.9026 57.9179 79.65 58.5 79.65C59.577 79.65 60.45 80.5231 60.45 81.6C60.45 82.5077 59.828 83.2751 58.984 83.4899C57.8901 83.7684 56.55 84.7754 56.55 86.475V87.45C56.55 88.527 57.423 89.4 58.5 89.4C59.577 89.4 60.45 88.527 60.45 87.45V87.1166C62.7212 86.3133 64.35 84.149 64.35 81.6C64.35 78.3691 61.731 75.75 58.5 75.75C56.7524 75.75 55.1821 76.5187 54.113 77.7299C53.4004 78.5374 53.4772 79.7697 54.2846 80.4823C55.092 81.195 56.3244 81.1181 57.0369 80.3107ZM58.5003 91.35C57.4233 91.35 56.5503 92.223 56.5503 93.3C56.5503 94.377 57.4233 95.25 58.5003 95.25H58.5198C59.5968 95.25 60.4698 94.377 60.4698 93.3C60.4698 92.223 59.5968 91.35 58.5198 91.35H58.5003Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_26801_3621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 117.5C25 115.567 26.567 114 28.5 114H56.5C58.433 114 60 115.567 60 117.5C60 119.433 58.433 121 56.5 121H28.5C26.567 121 25 119.433 25 117.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 130.5C25 128.567 26.567 127 28.5 127H37.5C39.433 127 41 128.567 41 130.5C41 132.433 39.433 134 37.5 134H28.5C26.567 134 25 132.433 25 130.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 117.5C65 115.567 66.567 114 68.5 114H87.5C89.433 114 91 115.567 91 117.5C91 119.433 89.433 121 87.5 121H68.5C66.567 121 65 119.433 65 117.5Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 130.5C46 128.567 47.567 127 49.5 127H74.5C76.433 127 78 128.567 78 130.5C78 132.433 76.433 134 74.5 134H49.5C47.567 134 46 132.433 46 130.5Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_26801_3621",
    x: 25,
    y: 113,
    width: 66,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 18,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_26801_3621"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6125 0 0 0 0 0.907 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_26801_3621"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.891667 0 0 0 0 0.93753 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_26801_3621",
    result: "effect2_innerShadow_26801_3621"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_3621",
    x1: 25,
    y1: 36.7188,
    x2: 167.969,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_3621",
    x1: 80,
    y1: 50,
    x2: 80,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_3621",
    x1: 109.406,
    y1: 62,
    x2: 202.417,
    y2: 126.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashcards);
export default __webpack_public_path__ + "static/media/Flashcards.6a9050b3312724f58f9717a7dfdf108c.svg";
export { ForwardRef as ReactComponent };